import { render, staticRenderFns } from "./ModalDirectorySkill.vue?vue&type=template&id=48bcc142&lang=pug&"
import script from "./ModalDirectorySkill.vue?vue&type=script&lang=js&"
export * from "./ModalDirectorySkill.vue?vue&type=script&lang=js&"
import style0 from "./ModalDirectorySkill.vue?vue&type=style&index=0&id=48bcc142&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports